export { Registry } from './src/index';
